
import { Vue } from "vue-class-component";

class Piece extends Vue {}
export default Piece;
